export const PlusCircleSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <circle opacity="0.5" cx="10" cy="10.8079" r="8" fill="#BEA2FF" />
    <path
      d="M15 11.5221H10.7143V15.8079H9.28571V11.5221H5V10.0936H9.28571V5.80786H10.7143V10.0936H15V11.5221Z"
      fill="#7200CB"
    />
  </svg>
);
